/**
 * @param {string} uuid 
 * @returns {boolean}
 */
export const isValidUuid = (uuid) => {
  const uuidV4Regex =
    /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/;
  return uuidV4Regex.test(uuid);
};

/**
 * @param {string} url
 * @param {number | null} requestedIndex
 * 
 * @returns {string}
 */
export default (url, requestedIndex = null) => {
  const uuid4s = url
    .split("/")
    .map((item) => item.toLowerCase())
    .filter((str) => isValidUuid(str));

  return uuid4s[requestedIndex ?? uuid4s.length - 1];
};
